import { useEffect, useMemo } from 'react';

import { TIER_POSITIONS } from 'utils/constants/cms';
import { findLastProductAndScroll } from 'utils/grid';
import { DEFAULT_LIMIT } from 'utils/helpers';

export function useGrid({ tiersProps, productsPerPage }) {
  const tiersInGrid = !!tiersProps[TIER_POSITIONS.GRID];
  const tiersIndexes = tiersInGrid ? tiersProps?.[TIER_POSITIONS.GRID]?.flatMap((tier) => tier.positionInGrid.map((pos) => pos)).sort((a, b) => a - b) : [];

  const pagesRange = useMemo(() => {
    const counted = productsPerPage.reduce((acc, products, page) => {
      // si es el primer elemento del array el minimo es 0, si no el minimo es el maximo del anterior + 1
      const min = !acc.length ? 0 : acc[page - 1][1] + 1;

      // const min = !acc.length ? 0 : acc[page - 1][1] + 1;
      let max = !products.length ? min + DEFAULT_LIMIT : min + products.length;
      tiersIndexes.forEach((tIndex) => {
        if (tIndex > min && tIndex <= max) {
          max = max + 1;
        }
      });
      acc.push([ min, max ]);
      return acc;
    }, []);
    return counted;
  }, [ productsPerPage, tiersIndexes ]);

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    history.scrollRestoration = 'manual';
    findLastProductAndScroll();
  }, []);
  return {
    pagesRange,
    tiersIndexes,
  };
}
